import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ invoiceMilestone }) => (
    <>
      <DateTime value={invoiceMilestone.date} /> &middot; {invoiceMilestone.invoiceItem?.name} &middot;{' '}
      <Currency value={invoiceMilestone.fee} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Invoice Milestones"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .invoiceMilestones()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1 ? 'the selected invoice milestone' : `the ${ids.length} selected invoice milestones`
      }. Invoiced milestones will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
